import React, { FC } from 'react';

import { SearchArticlesItem } from '../../common/api/searchArticles';
import { Loader } from '../../common/components/Loader';
import { ErrorTemplate } from '../../help-center/components/ErrorTemplate';
import { HelpCenterError } from '../../help-center/types';

type SolutionNotReadyProps = {
  solutions: SearchArticlesItem[] | null;
  query: string;
};

export const SolutionsNotReady: FC<SolutionNotReadyProps> = ({
  solutions,
  query,
}) => {
  if (query.length < 2) {
    return (
      <ErrorTemplate errorName={HelpCenterError.MORE_INFORMATION_NEEDED} />
    );
  }
  if (query.length > 1 && !solutions) {
    return (
      <Loader
        dataHook="solution-list__loader"
        height="100%"
        verticalAlign="middle"
      />
    );
  }
  if (!solutions?.length) {
    return <ErrorTemplate errorName={HelpCenterError.NO_ARTICLES} />;
  }
  return null;
};
